
import React from "react";

export function VendorFormatter(cellContent,row){

    return(
        <>
            <span className="text-dark-75 font-weight-bolder d-block font-size-lg text-center">
                {row.user[0].fullName}
            </span>
            <span className="text-muted font-weight-bold d-block text-center">
                {row.user[0].email}
            </span>
        </>
    )
}